import api from "./api";

export const getCompanyCustomThemes = async () => {
  const { data } = await api.get("themes/options");
  if (data?.themes) return data.themes;
  return data;
};
